// extracted by mini-css-extract-plugin
export default {"the_origin_header":"TheOriginHeader_the_origin_header__-GjUI"};